import { balanceStateName } from "./constants";

const getBalanceState = (store) => store[balanceStateName];
export const getUserBalance = (s) => getBalanceState(s).balance;
